import BaseService from '@/network/base-service'

class PrintService extends BaseService {
  constructor () {
    super(`${process.env.VUE_APP_API_BASE_URL}/paciente`)
  }
  obterPdfDocumento (params) {
    return this.get(`paciente/documentos/relatorios/${params.code}?data=${params.date}`, { responseType: 'blob' })
  }
  obterPdfAtestado (params) {
    return this.get(`paciente/documentos/relatorios/${params.id}?codigo=${params.code}&data=${params.date}`, { responseType: 'blob' })
  }
  obterDocumento (params) {
    return this.get(`paciente/pdf/${params.id}?data=${params.date}&prontuario=${params.prontuario}`, { responseType: 'blob' })
  }
  getPrintAllDocs (params) {
    const config = {
      headers: {
        'responseType': 'blob'
      }
    }
    return this.post(`paciente/documentos/relatorios?relatorios`, { ...params }, config)
  }
}
export default new PrintService()
